module.exports = { "default": require("core-js/library/fn/object/set-prototype-of"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /opt/atlassian/pipelines/agent/build/~/babel-runtime/core-js/object/set-prototype-of.js
// module id = 388
// module chunks = 0